import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppSettings } from '../../service/app-settings.service';
import { environment } from '../../../environments/environment';
import { Router, Routes } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../../app/service/login/login.service';
import { SpinnerService } from '../../../app/service/spinner-service/spinner.service';

const routes: Routes = [
  { path: 'home', redirectTo: '/Home' },
];


@Component({
  selector: 'loginv1',
  templateUrl: './loginv1.html'
})

export class LogInV1Page implements OnDestroy, OnInit {

  public Cuenta: string = '';
  public Password: string = '';

  loginForm: FormGroup;
  credencialesValidas: boolean = true
  loadingLogin: boolean = false

  appTitleHeaderStrong: string;
  appSubTitleHeaderLight: string;

  constructor(
    public appSettings: AppSettings,
    private router: Router,
    private spinnerService: SpinnerService,
    private loginService: LoginService,
    private fb: FormBuilder) {
    this.appSettings.appEmpty = true;

    this.appTitleHeaderStrong = environment.appTitleHeaderStrong;
    this.appSubTitleHeaderLight = "";

    this.loginForm = this.fb.group({
      cuenta: ['', [Validators.required]],
      password: ['', [Validators.required]]
    })
  }

  ngOnInit() {
    this.Cuenta = '';
    this.Password = '';

    //--Validando si las variables de sesión estan seteadas
    if (this.loginService.haySesionActiva() == true) {
      this.router.navigate(['/home']);
    }
  }

  ngClickAccess() {
    this.spinnerService.setMensaje('Iniciando sesión...')
    this.spinnerService.show()
    this.loadingLogin = true
    this.credencialesValidas = true
    this.loginService.getUsuario(this.loginForm.value.cuenta ,this.loginForm.value.password)
    .subscribe((obtenerItemResultado:any)=>{
      if (obtenerItemResultado.token !== null)
         {          
            //Setear las variables de sesion
            this.loginService.setVariablesSesion( obtenerItemResultado);

            const profile = localStorage.getItem("profile");

            switch (profile) {

              case 'Validador':
                this.router.navigate(['/proveedores/validar']);
                break;

              case 'Autorizador':
                this.router.navigate(['/aprobaciones']);
                break;

              case 'Autorizador Operativo':
                this.router.navigate(['/compras/solicitudes-por-aprobar']);
                break;

              default:
                this.router.navigate(['/home']);
                break;

            }
          
          
            this.spinnerService.hide()
         }
       else{
        this.loadingLogin = false
        this.spinnerService.hide()
        this.credencialesValidas = false
       }
    }, err => {
      this.loadingLogin = false
        this.spinnerService.hide()
        this.credencialesValidas = false
    })
   
  }

  ngOnDestroy() {
    this.appSettings.appEmpty = false;
  }
}
